import { Box, FormLabel, TextField } from "@mui/material";

export interface CampaignInfoStepProps {
  campaignName: string;
  onCampaignNameChange: (val: string) => void;
}

export default function CampaignInfoStep({ campaignName, onCampaignNameChange }: CampaignInfoStepProps) {
  return (
    <Box sx={{ display: "flex", mb: 1, flexDirection: "column" }}>
      <FormLabel htmlFor="campaign-name" sx={{ fontWeight: "bold", mb: 0.5 }} error={!campaignName}>
        Campaign Name *
      </FormLabel>
      <TextField
        defaultValue={campaignName}
        id="campaign-name"
        variant="outlined"
        onChange={(_ev) => onCampaignNameChange(_ev.target.value)}
      />
    </Box>
  );
}
